import { version as backofficeMonorepoApiVersion } from '../../package.json';
import { version as backofficeMonorepoVersion } from '../../../../package.json';

export abstract class ProjectData {
  public backofficeMonorepoVersion: string = backofficeMonorepoVersion;
  public backofficeMonorepoApiVersion: string = backofficeMonorepoApiVersion;
  abstract projectName: string;
}
